import { render, staticRenderFns } from "./MediaLibraryPicker.vue?vue&type=template&id=07aafe6c&scoped=true&"
import script from "./MediaLibraryPicker.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryPicker.vue?vue&type=script&lang=js&"
import style0 from "./MediaLibraryPicker.vue?vue&type=style&index=0&id=07aafe6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aafe6c",
  null
  
)

export default component.exports